import { Theme } from '@mui/material';

export const joinCommunitiesSectionStyles = (theme: Theme) => ({
	root: {
		display: 'flex',
		flexDirection: 'column',
		gap: '40px',
		mt: { xs: '100px', md: '160px' },
		px: { xs: '20px', md: '45px', lg: '60px' },
	},
});
